import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type Contact = ResultOf<typeof contactRecordQuery>["contact"];
export type ContactRecord = ResultOf<typeof contactRecordQuery>["contact"];
export const contactRecordQuery = graphql(`
  query ContactRecord($id: ID!) {
    contact(id: $id) {
      id
      type
      name
      legal_name
      purchase_order_number
      company_number
      billing_cycle_day_of_month
      billing_email
      billing_phone
      parentContact {
        name
        id
      }
      billingAddress {
        ...AddressFields
      }
      profilePicture {
        ...MediaFields
      }
      created_at
      updated_at
    }
  }
`);

export const contactRecordFragment = graphql(`
  fragment ContactRecordFields on Contact {
    id
    name
    legal_name
    company_number
    type
    purchase_order_number
    billing_cycle_day_of_month
    billing_email
    billing_phone
    profilePicture {
      ...MediaFields
    }
    billingAddress {
      ...AddressFields
    }
    profilePicture {
      ...MediaFields
    }
    created_at
    updated_at
  }
`);
